<template>
    <div class="login-container">
        <div class="row pb-5">
            <div class="col-lg-2 sidebar">
                <h1 class="font-weight-normal pb-3">Sign Up</h1>
                <div class="lines h-100 d-sm-none d-none d-lg-block"></div>
            </div>
            <div class="col-lg-10 pb-5">
                <section class="row">
                    <div class="col-lg-12">
                        <div v-if="passwordMismatch" class="alert alert-danger">
                            <strong>ERROR</strong>
                            <div>Password fields do not match</div>
                        </div>

                        <div v-if="passwordTooShort" class="alert alert-danger">
                            <strong>ERROR</strong>
                            <div>Your Password Must be at least 6 characters long.</div>
                        </div>

                        <success v-if="$route.query.register && $route.query.register=='true'">
                            <strong>SUCCESS</strong>
                            <div>
                                Your information was sent successfully. Please allow 24 hours for your account information you provided to be verified.
                                Once verified you will receive a confirmation email from Protective Industrial Products.</div>
                        </success>

                        <div v-if="signUpErrorMessage.length > 0" class="alert alert-danger">
                            <strong>ERROR</strong>
                            <div v-for="(error, index) in signUpErrorMessage" :key="index">
                                {{ error }}
                            </div>

                        </div>

                        <div v-if="$route.query.user && $route.query.user=='exists'">
                            <div class="alert alert-warning">
                                <strong>DUPLICATE EMAIL ADDRESS</strong>
                                <div>
                                    The email address has already been registered to an myPIP Customer Service Portal account.
                                    If you feel that you have received this message in error, please contact customer service at (855) 284-6800.
                                </div>
                            </div>
                        </div>

                        <div v-if="$route.query.verify===false || $route.query.access===false" class="alert alert-warning">
                            <strong>RESTRICTED AREA</strong>
                            <div>
                                You currently do not have access to this page. Please login with your email address and password below.
                            </div>

                        </div>



                        <!-- <div v-if="status === 'success'" class="alert alert-success">
                            <strong>SUCCESS</strong>
                            <div>
                                Your information was sent successfully. Please allow 24 hours for your account information you provided to be verified.
                                Once verified you will receive a confirmation email from Protective Industrial Products.
                            </div>
                        </div>

                        <div v-if="status === 'duplicate'" class="alert alert-warning">
                            <strong>DUPLICATE EMAIL ADDRESS</strong>
                            <div>
                                The email address has already been registered to an myPIP Customer Service Portal account.
                                If you feel that you have received this message in error, please contact customer service at (855) 284-6800.
                            </div>
                        </div>

                        <div v-if="status === 'restricted'" class="alert alert-warning">
                            <strong>RESTRICTED AREA</strong>
                            <div>
                                Please login with your email address and password below.
                                If you are having difficulties accessing our protected pages please contact customer service at (855) 284-6800.
                            </div>
                        </div> -->
                    </div>
                </section>
                <section class="pb-5">

                    <div class="row">
                        <div class="col-lg-1"></div>
                        <div class="col-lg-5">

                            <!-- Step 1 -->
                            <h3 class="mb-4" v-if="!isLoggedIn">
                                STEP 1: ENTER YOUR INFORMATION
                            </h3>
                            <h3 class="mb-4" v-if="isLoggedIn">
                                STEP 1: REVIEW YOUR INFORMATION
                            </h3>

                            <!-- Existing Distributor Tools Question -->
                            <div class="mb-4" v-if="!isLoggedIn">
                                <strong class="mb-3">
                                    DO YOU HAVE A DISTRIBUTOR TOOLS ACCOUNT WITH PIP?
                                </strong>

                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <button
                                            type="button"
                                            class="btn w-100 btn-danger"
                                            :class="hasDistributorAccount === true ? 'btn-danger' : 'btn-outline-secondary'"
                                            @click="showLogin"
                                        >
                                            <i class="fas fa-check"></i>YES
                                        </button>
                                    </div>

                                    <div class="col-md-6">
                                        <button
                                            type="button"
                                            class="btn w-100 btn-danger"
                                            :class="hasDistributorAccount === false ? 'btn-danger' : 'btn-outline-secondary'"
                                            @click="showSignup"
                                        >
                                            <i class="fas fa-times"></i>NO
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Existing Login Form -->
                            <form v-if="showLoginForm"  class="card mb-5">
                                <div class="card-body">
                                    <div class="mb-3">
                                        <label for="loginEmail" class="form-label fw-bold">
                                            EMAIL ADDRESS:
                                        </label>
                                        <input
                                            id="loginEmail"
                                            v-model="loginForm.email"
                                            type="email"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="mb-3">
                                        <label for="loginPassword" class="form-label fw-bold">
                                            PASSWORD:
                                        </label>
                                        <input
                                            id="loginPassword"
                                            v-model="loginForm.password"
                                            type="password"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="form-check mb-3">
                                        <input
                                            id="rememberMe"
                                            v-model="loginForm.remember"
                                            type="checkbox"
                                            class="form-check-input"
                                        >
                                        <label for="rememberMe" class="form-check-label">
                                            REMEMBER ME
                                        </label>
                                    </div>

                                    <button type="submit" class="btn btn-danger" @click.prevent="login">
                                        LOGIN
                                    </button>

                                    <div class="mt-3">
                                        <a href="/account/forgot-password/">
                                            Did you forget your password?
                                        </a>
                                    </div>
                                </div>
                            </form>

                            <!-- Signup Form -->
                            <form v-if="showSignupForm || loggedInUser" >

                                <div class="row g-3">
                                    <div class="col-12 mt-2">
                                        <label for="firstName" class="form-label fw-bold">
                                            FIRST NAME: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="firstName"
                                            v-model="signupForm.firstName"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="col-12 mt-2">
                                        <label for="lastName" class="form-label fw-bold">
                                            LAST NAME: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="lastName"
                                            v-model="signupForm.lastName"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="col-12 mt-2">
                                        <label for="title" class="form-label fw-bold">
                                            JOB TITLE: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="title"
                                            v-model="signupForm.title"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="col-12 mt-2">
                                        <label for="company" class="form-label fw-bold">
                                            COMPANY: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="company"
                                            v-model="signupForm.company"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <!-- <div v-if="showBranchField" class="col-12 mt-2">
                                        <label for="branch" class="form-label fw-bold text-danger">
                                            CINTAS LOCATION NUMBER:
                                        </label>
                                        <input
                                            id="branch"
                                            v-model="signupForm.branch"
                                            type="text"
                                            class="form-control"
                                        >
                                    </div> -->

                                    <div class="col-12 mt-2">
                                        <label for="address" class="form-label fw-bold">
                                            ADDRESS: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="address"
                                            v-model="signupForm.address"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="col-12 mt-1">
                                        <input
                                            id="address2"
                                            v-model="signupForm.address2"
                                            type="text"
                                            class="form-control"
                                            placeholder="Address 2"
                                        >
                                    </div>

                                    <div class="col-12 mt-2">
                                        <label for="city" class="form-label fw-bold">
                                            CITY: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="city"
                                            v-model="signupForm.city"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="col-12 mt-2">
                                        <label for="state" class="form-label fw-bold">
                                            STATE: <span class="text-danger">*</span>
                                        </label>
                                        <select
                                            id="state"
                                            v-model="signupForm.state"
                                            class="form-select"
                                            required
                                        >
                                            <option value="">---Select---</option>
                                            <option v-for="state in states" :key="state.value" :value="state.value">
                                                {{ state.label }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-12 mt-2">
                                        <label for="zipcode" class="form-label fw-bold">
                                            ZIP CODE: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="zipcode"
                                            v-model="signupForm.zip"
                                            type="text"
                                            class="form-control"
                                            required
                                        >
                                    </div>

                                    <div class="col-md-12 mt-2">
                                        <label for="phone" class="form-label fw-bold">
                                            PHONE: <span class="text-danger">*</span>
                                        </label>
                                        <input
                                            id="phone"
                                            v-model="signupForm.phone"
                                            type="tel"
                                            class="form-control"
                                            placeholder="555-555-5555"
                                            required
                                        >
                                    </div>

                                    <div class="col-md-12 mt-2">
                                        <label for="email" class="form-label fw-bold">
                                            EMAIL ADDRESS: <span class="text-danger">*</span>
                                        </label>
                                        <small class="text-muted mb-1" v-if="!isLoggedIn">
                                            (BUSINESS EMAIL ADDRESSES ONLY)
                                        </small>
                                        <small class="text-danger mb-1" v-if="isLoggedIn">
                                            (VERIFIED)
                                        </small>
                                        <input
                                            id="email"
                                            v-model="signupForm.email"
                                            type="email"
                                            class="form-control"
                                            required
                                        >
                                    </div>
                                </div>

                                <!-- Password -->
                                <div v-if="!isLoggedIn" class="mt-4">
                                    <strong class="mb-3 d-block">
                                        SET A PASSWORD FOR DISTRIBUTOR TOOLS
                                    </strong>
                                    <span class="d-block">
                                        By entering a password below, you will also be verified for the Distributor Tools section of www.pipuretail.com. Distributor Tools is where you can view and use Distributor ONLY content and tools that are not available to the general public. Once your information is verified, you will receive two emails from PIP. One for Distributor Tools access on www.pipretail.com and one for the myPIP Customer Portal.
                                    </span>

                                    <div class="row g-3">
                                        <div class="col-12">
                                            <label for="password" class="form-label fw-bold">
                                                PASSWORD: <span class="text-danger">*</span>
                                            </label>
                                            <input
                                                id="password"
                                                v-model="signupForm.password"
                                                type="password"
                                                class="form-control"
                                                required
                                            >
                                        </div>

                                        <div class="col-12 mt-2">
                                            <label for="passwordConfirmation" class="form-label fw-bold">
                                                CONFIRM PASSWORD: <span class="text-danger">*</span>
                                            </label>
                                            <input
                                                id="passwordConfirmation"
                                                v-model="signupForm.passwordConfirmation"
                                                type="password"
                                                class="form-control"
                                                required
                                            >
                                        </div>
                                    </div>
                                </div>

                                <!-- Step 2 -->

                            </form>

                        </div>
                        <div class="col-lg-1"></div>
                        <div class="col-lg-5">
                            <div>
                                <h3 class="mb-3">
                                    STEP 2: SELECT YOUR USER ROLE
                                </h3>

                                <div class="row g-4">
                                    <div
                                        v-for="role in roles"
                                        :key="role.value"
                                        class="col-md-6 col-lg-4 mb-2"
                                    >
                                        <label
                                            class="card h-100 text-center p-3 role-card "
                                            :class="{ 'border-danger shadow': signupForm.userRole === role.value }"
                                        >
                                            <input
                                                v-model="signupForm.userRole"
                                                type="radio"
                                                name="userRole"
                                                class="form-check-input mx-auto mb-2"
                                                :value="role.value"
                                                required
                                            >

                                            <img
                                                :src="role.image"
                                                :alt="role.label"
                                                class="img-fluid mx-auto mb-3"
                                                style="max-height: 100px;"
                                            >

                                            <strong>{{ role.label }}</strong>
                                        </label>
                                    </div>
                                </div>

                                <div v-if="selectedRole" class="alert alert-secondary mt-4">
                                    {{ selectedRole.description }}
                                </div>
                            </div>

                            <div class="text-center mt-5">
                                <button
                                    type="submit"
                                    class="btn btn-danger btn-lg px-5 btn-round-red pt-9rem"
                                    :disabled="!signupForm.userRole"
                                    @click.prevent="submitSignup"
                                >
                                    SIGN UP
                                </button>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .login-container{
        width:90%;
        margin:4em auto 0 auto;

        i{
            color:#cd1b00;
        }
        h1{
            border-bottom: 3px solid #efefef;
            font-size:3em;
            margin: 0 0 1.6rem 0;
            color:#111;
        }
        h3 {
            color: #cd1b00;
            font-weight:600;
            border-bottom:1px solid #cd1b00;
            margin-bottom:1em;
            span{
                font-weight: 400;
                font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
            }
        }
        .fas{
            color:#fff;
            padding-right:0.3rem;
        }
        label{
            text-transform: uppercase;
            font-weight:600;
            margin-bottom:0;
            span{
                font-size: 0.75rem;
                color: #666666;
                font-weight:400;
                margin: 1rem 0;
            }
        }
    }

</style>


<script>

import { isLoggedIn, logIn, logOut } from "../../components/utils/auth";
import { mapState, mapGetters } from "vuex";
export default {
    name: 'MyPipSignup',

    data() {
        return {
            isLoggedIn: false,
            hasDistributorAccount: null,
            showLoginForm: false,
            showSignupForm: this.isLoggedIn,
            signUpStatus:null,
            passwordMismatch: false,
            passwordTooShort: false,
            loading: false,
            signUpErrorMessage:[],

            loginForm: {
                email: '',
                password: '',
                remember: false,
            },

            signupForm: {
                firstName: '',
                lastName: '',
                title: '',
                company: '',
                branch: '',
                address: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                email: '',
                password: '',
                passwordConfirmation: '',
                userRole: '',
                userId:''
            },

            states: [
                { value: 'AL', label: 'Alabama' },
                { value: 'AK', label: 'Alaska' },
                { value: 'AZ', label: 'Arizona' },
                { value: 'AR', label: 'Arkansas' },
                { value: 'CA', label: 'California' },
                { value: 'CO', label: 'Colorado' },
                { value: 'CT', label: 'Connecticut' },
                { value: 'DE', label: 'Delaware' },
                { value: 'DC', label: 'District of Columbia' },
                { value: 'FL', label: 'Florida' },
                { value: 'GA', label: 'Georgia' },
                { value: 'HI', label: 'Hawaii' },
                { value: 'ID', label: 'Idaho' },
                { value: 'IL', label: 'Illinois' },
                { value: 'IN', label: 'Indiana' },
                { value: 'IA', label: 'Iowa' },
                { value: 'KS', label: 'Kansas' },
                { value: 'KY', label: 'Kentucky' },
                { value: 'LA', label: 'Louisiana' },
                { value: 'ME', label: 'Maine' },
                { value: 'MD', label: 'Maryland' },
                { value: 'MA', label: 'Massachusetts' },
                { value: 'MI', label: 'Michigan' },
                { value: 'MN', label: 'Minnesota' },
                { value: 'MS', label: 'Mississippi' },
                { value: 'MO', label: 'Missouri' },
                { value: 'MT', label: 'Montana' },
                { value: 'NE', label: 'Nebraska' },
                { value: 'NV', label: 'Nevada' },
                { value: 'NH', label: 'New Hampshire' },
                { value: 'NJ', label: 'New Jersey' },
                { value: 'NM', label: 'New Mexico' },
                { value: 'NY', label: 'New York' },
                { value: 'NC', label: 'North Carolina' },
                { value: 'ND', label: 'North Dakota' },
                { value: 'OH', label: 'Ohio' },
                { value: 'OK', label: 'Oklahoma' },
                { value: 'OR', label: 'Oregon' },
                { value: 'PA', label: 'Pennsylvania' },
                { value: 'RI', label: 'Rhode Island' },
                { value: 'SC', label: 'South Carolina' },
                { value: 'SD', label: 'South Dakota' },
                { value: 'TN', label: 'Tennessee' },
                { value: 'TX', label: 'Texas' },
                { value: 'UT', label: 'Utah' },
                { value: 'VT', label: 'Vermont' },
                { value: 'VA', label: 'Virginia' },
                { value: 'WA', label: 'Washington' },
                { value: 'WV', label: 'West Virginia' },
                { value: 'WI', label: 'Wisconsin' },
                { value: 'WY', label: 'Wyoming' },
            ],

            roles: [
                {
                    value: 'Lead',
                    label: 'Lead',
                    image: '/images/user-role-LR.svg',
                    description: 'Typically meant for the owner/president or senior manager, the Lead user has exclusive rights to grant and deny MyPIP access to users within the organization. Additionally, this person will have access to all the levels of functionality and visibility described in the proceeding user roles outlined below.',
                },
                {
                    value: 'Corporate Buyer',
                    label: 'Corporate Buyer',
                    image: '/images/user-role-CB.svg',
                    description: 'This is a full access role with the ability to view orders, shipments and invoices, along with prices for all branches or buying locations across the organization. The Corporate Buyer role cannot assign or deny users.',
                },
                {
                    value: 'Branch Buyer',
                    label: 'Branch Buyer',
                    image: '/images/user-role-BB.svg',
                    description: 'Typically assigned to buyers responsible for a particular branch or buying location, this role gives this person the ability to view orders, shipments and invoices, along with prices exclusively for their designated branch.',
                    hideForCountry: 'la',
                },
                {
                    value: 'Accounts Payable',
                    label: 'Accounts Payable',
                    image: '/images/user-role-AP.svg',
                    description: 'This role gives an Accounts Payable associate 24/7 access to customer invoices which includes invoice status and full order details.',
                },
                {
                    value: 'Expediter',
                    label: 'Expediter',
                    image: '/images/user-role-EX.svg',
                    description: 'For users with access to view and track sales orders and shipments to facilitate operational efficiency for the customer\'s organization.',
                },
                {
                    value: 'Sales Rep',
                    label: 'Sales Rep',
                    image: '/images/user-role-SR.svg',
                    description: 'This user role is especially useful for sales people on-the-go who want to review shipment and order status. myPIP provides access and order detail visibility, as well as shipment status with links to carriers.',
                    hideForCountry: 'la',
                },
            ],
        };
    },
    created() {
        if (this.isLoggedIn) {
            this.showSignupForm = true;
        }
    },

    computed: {
        ...mapState({ user: state => state.user }),
        loggedInUser() {

            if(this.user && Object.keys(this.user).length != 0){
                this.signupForm.userId=this.user.id;
                this.signupForm.firstName=this.user.f_name;
                this.signupForm.lastName=this.user.l_name;
                this.signupForm.title=this.user.title;
                this.signupForm.company=this.user.company;
                this.signupForm.address=this.user.add1;
                this.signupForm.address2=this.user.add2;
                this.signupForm.city=this.user.city;
                this.signupForm.state=this.user.state;
                this.signupForm.zip=this.user.zip;
                this.signupForm.phone=this.user.phone;
                this.signupForm.email=this.user.email;
                this.signupForm.cust_id=this.user.cust_id;
                this.isLoggedIn=true;
                return true;
            }else{
                return false;
            }
        },

        // showBranchField() {
        //     return this.signupForm.company.toLowerCase().includes('cintas');
        // },




        selectedRole() {
            return this.roles.find((role) => role.value === this.signupForm.userRole);
        },
    },

    methods: {
        showLogin() {
            this.hasDistributorAccount = true;
            this.showLoginForm = true;
            this.showSignupForm = false;
        },

        showSignup() {
            this.hasDistributorAccount = false;
            this.showLoginForm = false;
            this.showSignupForm = true;
        },

        // verify if the user email and password is correct
        async login(){
            window.scrollTo(0,0);
            this.loading=true;
            try {
                await axios.get(`/sanctum/csrf-cookie`);
                await axios.post(`/login`, {
                        email: this.loginForm.email,
                        password: this.loginForm.password
                    }).then(response=>{
                        if(response.data.success){
                            //save user information in the local storage
                            logIn(
                                response.data.user.email,
                                response.data.user.approved,
                                response.data.user.user_group_id
                            );
                            //updating login info
                            axios.get(`/api/user/update/login/${response.data.user.id}`);

                            //store user in state
                            this.$store.dispatch("loadUser");
                            this.isLoggedIn=true;

                            window.location.reload();


                        }
                        else{
                            this.loading=false;

                            switch(response.data.msg){
                                case "Not Verified":
                                    this.$router.push({ name: "login", query: {verify: "false"} });
                                    break;
                                case "No Access":
                                    this.$router.push({ name: "login", query: {access: "false"} });
                                    break;
                            }
                        }
                    }).catch(error => {
                        this.loading=false;
                        console.log(error);
                    });
            } catch (error) {

                this.loading=false;
                this.$router.push({ name: "login", query: {login: "false"} });

            }
        },


        async submitSignup() {
            this.loading=true;
            window.scrollTo(0,0);

            this.passwordMismatch = false;
            this.passwordTooShort = false;

            if (!this.isLoggedIn) {
                if (this.signupForm.password !== this.signupForm.passwordConfirmation) {
                    this.passwordMismatch = true;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return;
                }

                if (this.signupForm.password.length < 6) {
                    this.passwordTooShort = true;
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return;
                }

                try {
                    let checkUser={};
                    checkUser=await axios.get(`/api/getUserByEmail/${this.signupForm.email}`);

                    if(checkUser.data){
                        this.$router.push({ name: "portal-sign-up", query: {register: "false", user: "exists"} });
                    }else{
                        let user={
                            'firstname' : this.signupForm.firstName,
                            'lastname' : this.signupForm.lastName,
                            'title' : this.signupForm.title,
                            'company' : this.signupForm.company,
                            'address' : this.signupForm.address,
                            'address2' : this.signupForm.address2,
                            'city' : this.signupForm.city,
                            'state' : this.signupForm.state,
                            'zipcode' : this.signupForm.zip,
                            'phone' : this.signupForm.phone,
                            'email' : this.signupForm.email,
                            'password' : this.signupForm.password,
                            'password_confirmation' : this.signupForm.passwordConfirmation,
                        };
                        await axios.post(`/register`, user).then(response=>{
                             console.log('register done');
                             this.signupForm.userId=response.data.user.id;
                            axios.post(`/api/portal/create`, this.signupForm).then(response=>{
                                this.$router.push({ name: "portal-sign-up", query: {register: "true"} });
                                // initializing the user object
                                this.signupForm={};
                                this.loading=false;
                            }).catch(error => {
                                if (error.response && error.response.status === 422) {
                                    this.signUpErrorMessage = error.response.data.errors;
                                } else {
                                    this.signUpErrorMessage =[ "An unexpected error occurred. Try Again" ];
                                    console.log(error);
                                }
                            });
                        }).catch(error => {
                            if (error.response && error.response.status === 422) {
                                this.signUpErrorMessage = error.response.data.errors;
                            } else {
                                this.signUpErrorMessage =[ "An unexpected error occurred." ];
                                console.log(error);
                            }
                        });
                    }

                } catch (error) {
                    this.loading=false;
                    this.errors=error.response && error.response.data.errors;
                }
            }else{
                //if the user is already logged in, we will just update their role and send the rest of the information to the backend to be verified for portal access
                this.signupForm.password=null;
                this.signupForm.passwordConfirmation=null;
                try{
                    await axios.post(`/api/portal/create`, this.signupForm).then(response=>{

                        this.$router.push({ name: "portal-sign-up", query: {register: "true"} });
                                // initializing the user object
                        this.signupForm={};
                        this.loading=false;
                    }).catch(error => {
                        if (error.response && error.response.status === 422) {
                            this.signUpErrorMessage = error.response.data.errors;
                        } else {
                            this.signUpErrorMessage =[ "An unexpected error occurred." ];
                        }
                    });
                }catch(error){
                    this.loading=false;
                    this.errors=error.response && error.response.data.errors;

                }

            }


        },
    },
};
</script>

<style scoped>
.role-card {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.role-card:hover {
    border-color: #dc3545;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.08);
}
</style>
